module.exports = __webpack_public_path__ + "assets/img/d9dd9025f6a2c84a6903a2fd9fec25a5.png";